import React from "react";
import {
  Stack,
  RadioGroup,
  Radio,
  Text,
  TextLink,
} from "@origin-digital/ods-core";
import { Field, FieldProps } from "formik";
import { HandoverTypeEnum } from "../../types";
import { handoverTypeToMsg } from "../helper";
import ClaimFileUpload from "../../Claim/ClaimFileUpload";
import { CTReadOnlyHeader } from "../CTReadOnlyHeader";
import FormFieldLayout from "../../FormComponents/FormFieldLayout";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";

const HyperLinkText: React.FC = () => (
  <>
    <TextLink
      href="https://www.originenergy.com.au/wp-content/uploads/271/9096v25.Jul25.All_.OE-Account-Closure-and-Transfer-Request.pdf"
      target="_blank"
    >
      Account closure and transfer request
    </TextLink>
    <Text>
      form is to be signed by the account holder. Please check that all the
      fields match what's on the form to avoid unnecessary delays.
    </Text>
  </>
);

export const CloseTransferFormLegacyHeaderSection: React.FC = () => {
  const {
    formBehavior: { isElectricityReadOnly, isGasReadOnly },
    formikContext: {
      values: { closeTransfer },
    },
  } = useCloseTransferFormProps();

  const isHeaderReadOnly = isElectricityReadOnly || isGasReadOnly;

  if (isHeaderReadOnly) {
    return (
      <CTReadOnlyHeader
        handoverType={closeTransfer.handoverType}
        attachment={closeTransfer.fileMeta}
      />
    );
  }

  return (
    <Stack>
      <FormFieldLayout
        text={
          closeTransfer.handoverType === HandoverTypeEnum.CLOSE_AND_TRANSFER ? (
            <HyperLinkText />
          ) : undefined
        }
      >
        <Field name="closeTransfer.handoverType">
          {({ field }: FieldProps) => (
            <RadioGroup
              {...field}
              id="close-transfer-handover"
              name="closeTransfer.handoverType"
              label="Would you like to transfer or close the accounts?"
            >
              <Radio
                id="transfer"
                label={handoverTypeToMsg[HandoverTypeEnum.CLOSE_AND_TRANSFER]}
                value={HandoverTypeEnum.CLOSE_AND_TRANSFER}
                helperText="We will close your account and you can provide us with the customer’s details so we can contact them to ask them to set up an account with us."
              />
              <Radio
                id="close"
                label={handoverTypeToMsg[HandoverTypeEnum.CLOSE]}
                value={HandoverTypeEnum.CLOSE}
                helperText="Close the account and de-energise the site."
              />
            </RadioGroup>
          )}
        </Field>
      </FormFieldLayout>
      {closeTransfer.handoverType === HandoverTypeEnum.CLOSE_AND_TRANSFER && (
        <FormFieldLayout multipleFields>
          <Text>Signed close and transfer form</Text>
          <Field name="closeTransfer.signedTransferFormFiles">
            {({ field }: FieldProps) => <ClaimFileUpload field={field} />}
          </Field>
        </FormFieldLayout>
      )}
    </Stack>
  );
};
